import { useState, useEffect, useRef } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { gql, useMutation } from "@apollo/client";
import { useAuth } from "../Context/AuthContext";

const REFRESH = gql`
    mutation refreshToken($refreshToken: String!) {
        refreshToken(refreshToken: $refreshToken) {
            success
            errors
            payload
            token
            refreshToken
        }
    }
`;

const useFetch = ({
    method,
    url,
    data,
    headers = null,
    pagination = null,
    trigger = false,
    noHeader = false,
    argFunc = null,
    caller = null,
    params = null,
    errMessage = null,
    setter = null,
    isNew = false,
}) => {
    const [refetchStatus, setRefetchStatus] = useState(trigger);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState("");
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState();
    const [innerTrigger, setInnerTrigger] = useState(0);
    const controllerRef = useRef(new AbortController());
    const token = Cookies.get("access");
    const { authRefDispatch, authAccDispatch } = useAuth();
    const [refreshFunction, { data: dataRef }] = useMutation(REFRESH);

    const apiCall = async () => {
        try {
            const result = await axios.request({
                params: params,
                method: method,
                url: !!pagination
                    ? `https://api.bootweb.codeamooz.com/${url}/?page=${pagination.current}`
                    : !isNew
                    ? `https://api.bootweb.codeamooz.com/${url}/`
                    : `https://api.bootweb.codeamooz.com/${url}`,
                data: data,
                headers: !noHeader
                    ? {
                          Authorization: `JWT ${token}`,
                          "X-CSRFTOKEN": Cookies.get("csrftoken"),
                      }
                    : {},

                signal: controllerRef.current.signal,
            });
            //console.log(result);
            if (setter !== null) setter(result.data);
            if (caller !== null) caller.reFetch();
            if (argFunc !== null) argFunc(result.data);
            setRefetchStatus(false);
            setResponse(result.data);
            setStatus(result.status);
        } catch (error) {
            setError(error);
            errMessage(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (typeof trigger === "undefined" && !innerTrigger) return;
        // if (trigger) apiCall();
        if (refetchStatus) {
            setLoading(true);
            apiCall();
        }
    }, [innerTrigger]);

    const cancelRequest = () => {
        controllerRef.current.abort();
    };
    const reFetch = (type) => {
        // console.log("re", params);
        // apiCall(nData, params);
        setInnerTrigger(+new Date());
        setRefetchStatus(true);
        // if (type !== "post") setPostReq(true);
    };

    useEffect(() => {
        error.response?.status === 403 &&
            refreshFunction({
                variables: { refreshToken: Cookies.get("refresh") },
            });
    }, [error]);

    useEffect(() => {
        if (dataRef) {
            authRefDispatch({
                type: "LOGIN",
                refToken: dataRef?.refreshToken.refreshToken,
            });

            authAccDispatch({
                type: "LOGIN",
                accToken: dataRef?.refreshToken.token,
            });
            window.location.reload(true);
        }
    }, [dataRef]);

    return { response, error, loading, status, cancelRequest, reFetch };
};

export default useFetch;
